import React from 'react'
import './Navbar.scss';
import openseaIcon from '../../Images/opensea.png';
import discordIcon from '../../Images/discord.png';
import twitterIcon from '../../Images/twitter.png';
import instagramIcon from '../../Images/instagram.png';

function Navbar() {
    return (
        <div id='navbar'>
            <nav
                className='navbar navbar-expand-md navbar-dark bg-custom'>
                <div className="container-fluid navbarWidth">
                    <ul className="navbar-nav pe-3 mt-1 mb-md-0">
                        <li className="nav-item ml-md-2">
                            <a href=""><img className='socialIcon' src={openseaIcon} alt="opensea" /></a>
                            <a href=""><img className='socialIcon' src={discordIcon} alt="discord" /></a>
                            <a href=""><img className='socialIcon' src={twitterIcon} alt="twitter" /></a>
                            <a href=""><img className='socialIcon' src={instagramIcon} alt="instagram" /></a>
                        </li>
                    </ul>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarCollapse"
                            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul className="navbar-nav ms-auto pe-3 mt-1 mb-md-0">
                            <li className="nav-item ml-md-2">
                                <a className="nav-link" href="#home">Home</a>
                            </li>
                            <li>
                                <p className="navSlash" >/</p>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#showcase">Showcase</a>
                            </li>
                            <p className="navSlash" >/</p>
                            <li className="nav-item">
                                <a className="nav-link" href="#roadmap">Roadmap</a>
                            </li>
                            <p className="navSlash" >/</p>
                            <li className="nav-item">
                                <a className="nav-link" href="#team">Team</a>
                            </li>
                            <p className="navSlash" >/</p>
                            <li className="nav-item">
                                <a className="nav-link" href="#about">About</a>
                            </li>
                            <p className="navSlash" >/</p>
                            <li className="nav-item">
                                <a className="nav-link" href="#faq">FAQ</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
